import { sumAmountsMinor, } from "./money.js";
export class InvoiceSnapshotError extends Error {
}
/**
 * Builds the frozen snapshot payload from a draft invoice's resolved line
 * items. Every line item must already share `currency` — Accounting never
 * mixes currencies on one invoice (a bill in a different currency is
 * excluded from this roll-up rather than silently summed across units);
 * callers are responsible for that grouping before calling this.
 */
export function buildInvoiceSnapshot(input) {
    if (input.lineItems.length === 0) {
        throw new InvoiceSnapshotError("An invoice cannot be approved with zero line items.");
    }
    const totalMinor = sumAmountsMinor(input.lineItems.map((item) => item.amountMinor));
    return {
        invoiceId: input.invoiceId,
        stableId: input.stableId,
        stableName: input.stableName,
        horseId: input.horseId,
        ownerHorsemanId: input.ownerHorsemanId,
        dateRangeStart: input.dateRangeStart,
        dateRangeEnd: input.dateRangeEnd,
        currency: input.currency,
        lineItems: input.lineItems,
        totalMinor,
        generatedAt: input.generatedAt.toISOString(),
        approvedAt: input.approvedAt.toISOString(),
        approvedByHorsemanId: input.approvedByHorsemanId,
    };
}
